module.exports = __webpack_public_path__ + "img/img-fundanow-404.72ed2970.png";